import { createWorkflow } from './create'
import { readWorkflows, readWorkflow } from './read'
import { resourceObject } from './resourceObject'
import { rewindWorkflow } from './rewind'

export const workflows = {
  create: createWorkflow,
  readCollection: readWorkflows,
  readSingle: readWorkflow,
  resourceObject,
  rewind: rewindWorkflow,
}

export * from './queryHelpers'
export { replaceMomentWorkflows } from './cacheTransformFns/replaceMomentWorkflows'
export * from './readMomentWorkflows'
export { refreshMomentWorkflows } from './refreshMomentWorkflows'
